export type Regional = {
  idDistribuidor: string;
  nomeCompletoDistribuidor: string;
  regiaoUL: string;
  estado: string;
};

export type RegionalChange = {
  idDistribuidor: string;
  nomeDistribuidor: string;
  valorAnterior: string;
  valorNovo: string;
};

export type HistoryEntry = {
  id: string;
  date: string;
  user: string;
  changes: RegionalChange[];
};

export const REGIAO_UL_OPTIONS = [
  'Sul',
  'São Paulo',
  'Centro-Norte',
  'Leste',
  'Nordeste',
  'Não definido',
] as const;

export const REGIAO_UL_DROPDOWN_OPTIONS = [
  'Sul',
  'São Paulo',
  'Centro-Norte',
  'Leste',
  'Nordeste',
] as const;

export type ImportRow = {
  idDistribuidor: string;
  nomeDistribuidor: string;
  regiaoUL: string;
  valid: boolean;
  reason?: string;
  changeType?: 'changed' | 'unchanged';
  currentRegiaoUL?: string;
};
